

export const CONSTANTS = Object.freeze({
  IPC_CARD_TITLE: 'IPC Status',
  ITEM_CARD_TITLE: 'Details',
  PIPE_STATUS_CARD_TITLE: 'Pipe Status',
  MACHINING_CARD_TITLE: 'Connection Status',
  HARDBANDING_CARD_TITLE: 'Hardbanding',
})